import React from 'react';
// import { FaTimes } from 'react-icons/fa';
import './App.css';
import Header from './Components/Header';
import Hero from './Components/Hero';
import MainHeader from './Components/MainHeader';
import Service from './Components/ServiceSection';
import Testimonial from './Components/Testimonial';
import Hero2 from './Components/Hero2';
import Footer from './Components/Footer';
import ServicesCTABanner from './Components/ServicesCTABanner';
import ProcessSection from './Components/ProcessSection';
import TechStack from './Components/TechStack';
import SEOHelmet from './Components/SEOHelmet';
// import Maintenance from './Components/Maintenance';

const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Octalbees",
    "url": "https://www.octalbees.com",
    "logo": "https://www.octalbees.com/Images/logo-white.png",
    "description": "Octalbees is a technology company offering premium web development, app development, AI/ML, data engineering, digital marketing, and UI/UX design services.",
    "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+91-9470506529",
        "contactType": "customer service",
        "email": "info@octalbees.com",
        "availableLanguage": ["English", "Hindi"]
    },
    "sameAs": [
        "https://instagram.com/octalbees_",
        "https://www.linkedin.com/company/octalbees/"
    ]
};

const Home = () => {
    // const [showBanner, setShowBanner] = useState(false);

    // useEffect(() => {
    //     // Show banner after 5 seconds on the homepage
    //     const timer = setTimeout(() => {
    //         setShowBanner(true);
    //     }, 5000);

    //     return () => clearTimeout(timer);
    // }, []);

    // useEffect(() => {
    //     if (showBanner) {
    //         document.body.style.overflow = 'hidden';
    //         document.documentElement.style.overflow = 'hidden';
    //     } else {
    //         document.body.style.overflow = '';
    //         document.documentElement.style.overflow = '';
    //     }
    //     return () => {
    //         document.body.style.overflow = '';
    //         document.documentElement.style.overflow = '';
    //     };
    // }, [showBanner]);

    return (
        <div className="Home">
            {/* Promotional Banner Modal */}
            {/* {showBanner && (
                <div className="program-banner-overlay" onClick={() => setShowBanner(false)}>
                    <div className="program-banner-content" onClick={(e) => e.stopPropagation()}>
                        <button className="program-banner-close" onClick={() => setShowBanner(false)}>
                            <FaTimes />
                        </button>
                        <a href="/programs/ai-powered-full-stack-developer" onClick={() => setShowBanner(false)}>
                            <img src="/Images/poster_live_class.png" alt="Next Batch Starting Soon" className="program-banner-image" />
                        </a>
                    </div>
                </div>
            )} */}
            <SEOHelmet
                title="Octalbees – Web & App Development, AI, Design & Marketing Experts"
                description="Octalbees offers premium web development, app development, AI/ML solutions, data engineering, digital marketing, and UI/UX design services to scale your business."
                path="/"
                jsonLd={organizationSchema}
            />
            {/* <Maintenance /> */}
            <Header />
            <MainHeader />
            <Hero />
            <TechStack />
            <Service />
            <ProcessSection />
            <Testimonial />
            <Hero2 />
            <ServicesCTABanner />
            <Footer />
        </div>
    )
}

export default Home